import AssessmentFallback from 'components/modules/fallback/AssessmentFallback';
import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store/rootReducer';
import { Outlet } from 'react-router-dom';

const messageMapping = {
  error_basic:
    'You must select one of the roles in the profile section before accessing it.'
};

function CandidateAssessmentRouteHandler() {
  const user = useSelector((state: RootState) => state.user.user);
  const errorMode = !user.info.role ? 'error_basic' : null;
  return errorMode ? (
    <AssessmentFallback message={messageMapping[errorMode]} />
  ) : (
    <Outlet />
  );
}

export default CandidateAssessmentRouteHandler;
